import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import SalesExecutives from './components/SalesExecutives';
import VendorManagement from './components/VendorManagement';
import CategoryManagement from './components/CategoryManagement';
import SubscriptionManagement from './components/SubscriptionManagement';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import './styles/theme.css';
import ApprovalsManagement from './components/ApprovalsManagement';
import CommissionManagement from './components/CommissionManagement';
import ReportsManagement from './components/ReportsManagement';
import VendorCertificateApplications from './components/VendorCertificateApplications';
import SettingsManagement from './components/SettingsManagement';
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<AdminLogin />} />
        <Route
          path="/dashboard"
          element={
            <AdminProtectedRoute>
              <AdminDashboard />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/executives"
          element={
            <AdminProtectedRoute>
              <SalesExecutives />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/vendors"
          element={
            <AdminProtectedRoute>
              <VendorManagement />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/categories"
          element={
            <AdminProtectedRoute>
              <CategoryManagement />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/subscriptions"
          element={
            <AdminProtectedRoute>
              <SubscriptionManagement />
            </AdminProtectedRoute>
          }
        />

        <Route 
        path="/approvals"
        element={
          <AdminProtectedRoute>
            <ApprovalsManagement />
          </AdminProtectedRoute>
        }
        />

        <Route
  path="/commissions"
  element={
  <AdminProtectedRoute>
    <CommissionManagement />
    </AdminProtectedRoute>
  }
/>

        <Route 
        path="/reports"
        element={
          <AdminProtectedRoute>
            <ReportsManagement />
          </AdminProtectedRoute>
        }
        />
        

        <Route 
  path="/vendor-certificate-applications"
  element={
    <AdminProtectedRoute>
      <VendorCertificateApplications />
    </AdminProtectedRoute>
  }
/>

<Route 
  path="/settings"
  element={
    <AdminProtectedRoute>
      <SettingsManagement />
    </AdminProtectedRoute>
  }
/>
          
      
      </Routes>
    </BrowserRouter>
  );
}